import { render, staticRenderFns } from "./SimpleRoundedLoader.html?vue&type=template&id=4490387b&scoped=true&lang=html&"
import script from "./index.vue?vue&type=script&lang=ts&"
export * from "./index.vue?vue&type=script&lang=ts&"
import style0 from "./SimpleRoundedLoader.scss?vue&type=style&index=0&id=4490387b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4490387b",
  null
  
)

export default component.exports